<template>
  <div id="content" :style="pageBgStyles" :key="image">
    <transition name="fade" mode="out-in">
      <service v-if="service.title" :service="service" :windowWidth="windowWidth"></service>
      <div v-else class="error">
        Ошибка, данной услуги не существует
      </div>
    </transition>
  </div>
</template>

<script>
  import pageBgStyles from '../common/js/page-bg-styles'
  import Service from './Service'
  export default {
    mixins: [pageBgStyles],
    data () {
      return {
      }
    },
    props: ['name', 'windowWidth'],
    components: {
      Service
    },
    computed: {
      service () {
        try {
          return require('../data/' + this.$route.params.name)[0]
        } catch (e) {
          return {}
        }
      },
      image () {
        return '/static/services/bg/' + this.$route.params.name + '.jpg'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ServiceWrapper.vue?bff764c6